module.exports = __webpack_public_path__ + "static/map_usa_WE_mobile-c93ac19b6f89ae5537594072706371c1.png";